import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { eurekaApiUrlPrefix } from '@telecom/shared/domain-config';
import type { EurekaAmountsControl, EurekaAmountsControlApi } from '../eureka-amounts-control-api';

@injectable()
export class EurekaAmountsControlApiImpl extends PsHttpService implements EurekaAmountsControlApi {
    get options() {
        return {
            baseURL: eurekaApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async getAmountsControl(): Promise<EurekaAmountsControl> {
        const result = await this.get<PatSnapSuccessResponseData<EurekaAmountsControl>>({
            url: '/amounts/control',
        });
        return result.data || {};
    }
}
